import React from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import environment from "environment";
import Analytics from "./Components/Analytics/Analytics";
import { useUser, AuthWrapper } from "@dreamchimney/user-context";

import "./css/global.less";
import "./css/layout.less";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import LoginModal from "@dreamchimney/user-login";

import HomePage from "./Pages/Home/HomePage";
import PreviousPage from "./Pages/Previous/PreviousPage";
import AddQuotePage from "./Pages/Add/AddQuotePage";
import ScrollToTop from "./Components/Global/ScrollToTop";
import DevBanner from "./Components/Global/DevBanner";
import QuotePage from "./Pages/Quote/QuotePage";

const NoMatchPage = () => {
  return (
    <div className="header-page-not-found">
      <h3>Bummer. Page Not Found.</h3>
      <div className="col-text-center">
        <Link to="/">Back to Home</Link>
      </div>
    </div>
  );
  // return <Redirect to="/" />;
};

// @TODO
// Router basename
// Analytics basename

const App = () => {
  const { state: userState, dispatch } = useUser();

  const handleLoginAction = (payload) => {
    const { dispatch: payloadDispatch = {} } = payload;
    const promiseActions = [];
    Promise.all(promiseActions).then(() => {
      dispatch(payloadDispatch);
    });
  };
  const modalClosed = () => dispatch({ type: "signin_close" });

  return (
    <div className="quotes-app">
      <DevBanner />

      <Router basename="/quotes">

        <AuthWrapper>
          <Container className="app-container" fluid={false}>
            <Row>
              <Col xs={12}>
                <div className="middleWrapper">
                  <div className="mainSection">
                    <div className="contentPadding">
                      <div className="quote-wrapper">
                        <Link to={`/`}>
                          <img
                            src="https://www.dreamchimney.com/quotes/img/header.png"
                            alt="Quote of the Day"
                            className="img-responsive qotd-header"
                          />
                        </Link>
                        <Analytics basename="/quotes" local={environment.isDevelopment}>
                          <ScrollToTop />

                          <Switch>
                            <Route exact path="/previous" name="previous" component={PreviousPage} />
                            <Route exact path="/quote/:date" name="add" component={QuotePage} />
                            <Route exact path="/add" name="add" component={AddQuotePage} />
                            <Route exact path="/" name="home" component={HomePage} />

                            <Route path="*">
                              <NoMatchPage />
                            </Route>
                          </Switch>
                        </Analytics>
                      </div>
                    </div>
                  </div>
                  <LoginModal show={userState.signin} onClose={modalClosed} onLoggedin={handleLoginAction} onRegister={handleLoginAction} />
                  <div className="footer font-white col-text-center">
                    Copyright &copy; {new Date().getFullYear()}{" "}
                    <a href="//www.dreamchimney.com/" target="_top">
                      Dream Chimney
                    </a>{" "}
                    Inc.
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </AuthWrapper>
      </Router>
    </div>
  );
};

export default App;
